export enum UserRoles {
  GUEST = 0,      
  ADMIN = "Administrator", /* Bussiness Owner Can see/modify every thing */
  LAB_MANAGER = "Lab Manager", /* Lab Manager: Can See/modify everything releated their Lab */
  LAB_TECHNICIAN = "Lab Technician", /* Lab Technician: Can only update test status and add reference number to lab test*/
  PROBATION_DIRECTOR = "Probation Director", /* Probation Director: Can see/update everything related to Probatoiners */
  PROBATION_OFFICER = "Probation Officer", /* Probation Officer: Can see everything related to Assigned Probatoiners */
  PROBATION_USER = "Probation User", /* Probation User: Can see their own information */
  USER = 7,

}
